import { AuthService, PermissionService } from '@abp/ng.core';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GoliathAppPermission } from '@digiwall/goliath-core/config';
import { AccessibleRoutesService } from './accessible-routes.service';

/**
 * Application-wide gate. An authenticated user gets in when they are a full ERP user
 * (`Goliath.App.Access`) or, failing that, when the menu offers them at least one screen —
 * a role holding a single screen permission must not dead-end on "access denied".
 */
export const appAccessGuard: CanActivateFn = () => {
  if (!inject(AuthService).isAuthenticated) {
    return true;
  }

  if (inject(PermissionService).getGrantedPolicy(GoliathAppPermission.Access)) {
    return true;
  }

  if (inject(AccessibleRoutesService).hasAnyAccessibleScreen()) {
    return true;
  }

  return inject(Router).parseUrl('/access-denied');
};
